import React, { useEffect } from 'react'

export default function Toast({ children, onClose }){
  useEffect(()=>{
    const t = setTimeout(()=> onClose?.(), 2200)
    return ()=> clearTimeout(t)
  },[])
  return <div className="toast">{children}</div>
}
